(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.rafPending = false;
      // Ignore sub-pixel / momentum jitter when deciding scroll direction.
      this.directionThreshold = 4;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    onResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.measure(), 150);
    }

    // The header is position:fixed, so its rect is already viewport-relative and
    // doubles as the scroll threshold - adding scrollTop would make it drift.
    measure() {
      const rect = this.header.getBoundingClientRect();

      this.headerBounds = { top: rect.top, bottom: rect.bottom };
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.measure();

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Coalesce every scroll event into a single frame of work. Previously each
      // event queued its own requestAnimationFrame plus a 300ms timer, so a
      // normal scroll fired dozens of overlapping hide/reveal cycles.
      if (this.rafPending) return;

      this.rafPending = true;

      requestAnimationFrame(() => {
        this.rafPending = false;
        this.update();
      });
    }

    update() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const delta = scrollTop - this.currentScrollTop;
      const pastHeader = scrollTop > this.headerBounds.bottom;
      const atTop = scrollTop <= this.headerBounds.top;

      // Follow the "show on scroll up" setting on every viewport. Forcing the
      // hide/reveal dance on mobile regardless of the setting was what made the
      // header flicker there.
      if (this.scrollUpActive) {
        if (atTop) {
          this.reset();
        }
        else if (pastHeader) {
          if (delta > this.directionThreshold) {
            this.hide();
          }
          else if (delta < -this.directionThreshold) {
            if (this.preventReveal) {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              this.hide();
            }
            else {
              this.reveal();
            }
          }
        }
      }
      else {
        // Sticky, always visible: no hide/reveal flip, just pin and unpin.
        if (pastHeader) {
          this.reveal();
        }
        else if (atTop) {
          this.reset();
        }
      }

      if (Math.abs(delta) > this.directionThreshold || atTop || !pastHeader) {
        this.currentScrollTop = scrollTop;
      }
    }

    hide() {
      if (this.header.classList.contains('shopify-section-header-hidden')) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate', 'shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.sticky()) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      if (!this.header.classList.contains('shopify-section-header-sticky')) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();
})();
